/**
 * MSAL compatibility shim — provides the same API surface as @azure/msal-react
 * and @azure/msal-browser but backed by Supabase auth.
 *
 * Allows existing pages to keep their useMsal/useIsAuthenticated usage
 * without modification beyond the import path.
 */
import { supabase } from './supabaseClient';
import { useAuth } from '../Context/TokenContext';

export const InteractionStatus = {
    None: 'none',
    Login: 'login',
    Logout: 'logout',
    AcquireToken: 'acquireToken',
    SsoSilent: 'ssoSilent',
    HandleRedirect: 'handleRedirect',
};

export const useIsAuthenticated = () => {
    const { session } = useAuth();
    return !!session;
};

export const useMsal = () => {
    const { user } = useAuth();

    return {
        instance: {
            logoutRedirect: async ({ postLogoutRedirectUri } = {}) => {
                await supabase.auth.signOut();
                window.location.href = postLogoutRedirectUri || '/';
            },
            loginRedirect: () => {
                window.location.href = '/login';
            },
            getActiveAccount: () => user || null,
            getAllAccounts: () => (user ? [user] : []),
        },
        inProgress: InteractionStatus.None,
        accounts: user ? [user] : [],
    };
};
